import { createSelector } from 'reselect';
import { shouldShowChannelCover } from 'widget/utils/overlay-buttons-utils';
import { getChannelForWidget } from 'shared/selectors/channels';


const getVideo = (state, props) => props.videoItem;
const getShowChannelCover = (state, props) => props.showChannelCover;
const getSettings = state => state.appSettings;

export const getPlayerCoverUrl = createSelector(
  [
    getSettings,
    getChannelForWidget,
    getVideo,
    getShowChannelCover,
  ],
  (settings, channel, video, showChannelCover) => {

    const { customCoverUrl, coverUrl } = video;

    let url = customCoverUrl || coverUrl;

    if (shouldShowChannelCover(settings, showChannelCover)) {
      url = channel.customCoverUrl || channel.coverUrl || url;
    }

    return url;
  }
);



// WEBPACK FOOTER //
// ./src/widget/components/player-cover/player-cover-selector.js